import styles from './index.module.scss';
import SectionPro from '../components/SectionPro';
import EFPicture from '@elem/compCommon/EFPicture';
import FSwiper from '../components/FSwiper';

const SocialContributionActivities: React.FC = () => {
    const items = [
        {
            title: '災害支援活動（能登半島）',
            desc: '石川県 株洲市の避難所で、大容量で多ポートのポータブル電源が照明への給電やスマ－トフォンの充電に活用されました。',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744983398093/%E8%83%BD%E7%99%BB%E5%8D%8A%E5%B3%B6%E5%AF%84%E8%B4%88.jpg',
            h5: '',
        },
        {
            title: '富山県 富山消防局の災害支援活動をサポート',
            desc: '高出力のポータブル電源でヒーターを稼働させ、暖かく安全な環境作りに貢献しています。',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744983440130/%E5%AF%8C%E5%B1%B1%E6%B6%88%E9%98%B2%E5%B1%80%E3%81%AE%E7%81%BD%E5%AE%B3%E6%94%AF%E6%8F%B4%E6%B4%BB%E5%8B%95%E3%82%92%E3%82%B5%E3%83%9B%E3%82%9A%E3%83%BC%E3%83%88.jpg',
            h5: '',
        },
        {
            title: '仮設住宅の防災無線用バックアップ電源として活用',
            desc: '災害発生時の迅速かつ確実な情報伝達に貢献しています。',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744983519060/3.jpg',
            h5: '',
        },
        {
            title: '衛星通信の電源として活用し、被災者や復旧に携わる人々を支援',
            desc: '大切な家族との連絡や、円滑な復旧作業に重要な通信手段の確保に貢献しています。',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744983518870/4.jpg',
            h5: '',
        },
    ];
    return (
        <div
            className={`${styles.SocialContributionActivities} GtmModuleData-section`}
            data-section-id={styles.SocialContributionActivities}
            data-section-title="社会貢献活動"
        >
            <SectionPro title="社会貢献活動">
                <div className="list">
                    <FSwiper>
                        {items.map((item) => {
                            return (
                                <div className="item" key={item.title}>
                                    <EFPicture src={item.pc} />
                                    <div className="text-box">
                                        <div className="title">{item.title}</div>
                                        <div className="desc">{item.desc}</div>
                                    </div>
                                </div>
                            );
                        })}
                    </FSwiper>
                </div>
            </SectionPro>
        </div>
    );
};

export default SocialContributionActivities;
